export default __webpack_public_path__ + "static/media/KZ.T.13.2490.7f2e928f.svg";